import React from 'react'
import { Container } from './component.styles'
import { CustomCheckBox } from '../CustomCheckBox/component'
import { SITE_CHANGE_MESSAGE } from './constant'

interface SiteChangeConfirmationProps {
  siteChangeChecked: boolean
  setFieldValue: (field: string, value: boolean) => void
}

const SiteChangeConfirmation: React.FC<SiteChangeConfirmationProps> = ({
  siteChangeChecked,
  setFieldValue,
}) => {
  const handleChange = (): void => {
    setFieldValue('siteChangeChecked', !siteChangeChecked)
  }

  return (
    <Container siteChangeChecked={siteChangeChecked}>
      <CustomCheckBox
        checked={siteChangeChecked}
        isDisabled={false}
        name="siteChangeChecked"
        onChange={handleChange}
        text={SITE_CHANGE_MESSAGE}
      />
    </Container>
  )
}

export default SiteChangeConfirmation
